@import '../../../../constants/spacing.module.less';

.modal-body-text {
  font-size: 14px;
  line-height: 21px;
  padding: @space-24 @space-16 0;
}

.inactive-modal-body-text {
  font-size: 14px;
  line-height: 21px;
  padding: @space-24 @space-16 @space-48;
}

.modal-body-confirm-agreement {
  padding: @space-16 @space-16 @space-48;
}

.checkbox-label {
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
}

.checkbox-container {
  font-size: 14px;
  line-height: 16px;
  padding: @space-4 0;
}

.ss-settings-modal-footer {
  padding: @space-8 @space-16;
  height: 68px;
}
